<template>
  <template v-if="modalOpen">
    <AppPromptPostClickout v-if="showAppPrompt" @close="onClose" />
    <SubscribeModal
      v-else-if="!$cookie.getSigned()"
      :comparison-id="comparisonId"
      :current-tab="currentTab"
      creation-location="post_clickout_prompt"
      @close="onClose"
    />
  </template>
</template>

<script lang="ts" setup>
import { getSlugFromLink } from '@core/plugins/analytics/provider-clickout'
import type { Provider } from './types'
import SubscribeModal from './subscribe-modal.vue'
import type { PaymentType } from '@core/types/imt'

const ONE_DAY = 86400000
const POPUP_CLOSED_KEY = 'imtAlertsPopupClosed'

defineProps<{
  comparisonId: string
  currentTab: PaymentType
  cheapestProvider: Provider
}>()

const { $features, $cookie } = useNuxtApp()

const { redirectUrl } = useRuntimeConfig().public

const modalOpen = ref(false)

const showAppPrompt = computed(
  () => $features?.getValue('app_prompt_post_clickout') === 'on' && !__IS_MOBILE_APP__,
)

onMounted(() => {
  document.addEventListener(
    'click',
    async ({ target }) => {
      const link = target instanceof Element ? target.closest('a') : null
      if (link?.href.includes(redirectUrl)) {
        const slug = getSlugFromLink(link.href, redirectUrl)
        if (slug) {
          await openModal()
        }
      }
    },
    true,
  )
})

async function openModal() {
  const lastClosed = await storage.getValue(POPUP_CLOSED_KEY)
  if (lastClosed && Date.now() - Number(lastClosed) < ONE_DAY) {
    return
  }
  modalOpen.value = true
}

async function onClose() {
  modalOpen.value = false
  await storage.setValue(POPUP_CLOSED_KEY, String(Date.now()))
}
</script>
